
















































import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { SourceTypes } from '@/config/map.conf';

/**
 * rg操作记录
 *
 * @author liyuyao
 * @date 11/07/2019
 */
@Component
export default class RgHistory extends PaginationMixin {
    historyList: CommonTypes.RgHistoryItem[] = [];
    rgId: number = 0;
    tableLoading: Boolean = true;

    sourceTypes: CommonTypes.mapObject[] = SourceTypes;

    $mtd: any;
    created() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
        this.getRgHistory();
    }
    async getRgHistory(sourceType?) {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.getRgHistory({
                cn: this.currentPage,
                sn: this.limit,
                rgId: this.rgId,
                sourceType: sourceType || ''
            });
            const { code, data } = res;
            if (code === 200) {
                this.historyList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getRgHistory();
                }
            }
            this.total = res.data.tn;
        } catch (e) {
            this.historyList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    sourceTypeFilter(sourceType) {
        this.getRgHistory(sourceType);
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getRgHistory();
    }
}
